import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "button", "panel"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
    this.setOpen(false)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  toggle(event) {
    event.preventDefault()
    this.setOpen(!this.open)
  }

  close(event) {
    if (event) event.preventDefault()
    this.setOpen(false)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return

    this.setOpen(false)
  }

  get open() {
    return this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")
  }

  setOpen(open) {
    if (this.hasPanelTarget) this.panelTarget.classList.toggle("hidden", !open)
    if (this.hasBackdropTarget) this.backdropTarget.classList.toggle("hidden", !open)
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", open ? "true" : "false")
  }
}
